import React, { useEffect, useState } from 'react';
import { TransformComponent, TransformWrapper } from 'react-zoom-pan-pinch';

export type ImagePopupProps = {
    path: string | null;
    onClose: () => void;
}

export default function ImagePopup(props: ImagePopupProps) {

    const [isOpen, setIsOpen] = useState<boolean>(false);

    useEffect(() => {

        if (props.path !== null && props.path.trim().length > 0) {
            setIsOpen(true);
        }
        
        return () => { }
    }, [props.path])

    const onCloseClick = () => {
        setIsOpen(false);
        setTimeout(() => {
            props.onClose();
        }, 200);
    }

    if (isOpen === false) return null;

    return (

        <div className='imagePopup'>
            <div className='imagePopupSubContainer'>
                <TransformWrapper
                    centerOnInit={true}
                    centerZoomedOut={true}
                    initialScale={1}
                >
                    {({ zoomIn, zoomOut, resetTransform, ...rest }) => (
                        <div className='wrapper'>
                            <div className="tools" >
                                <button className='button' onClick={() => zoomIn()}>Zoom +</button>
                                <button className='button' onClick={() => zoomOut()}>Zoom -</button>
                                <button className='button' onClick={() => resetTransform()}>Redefinir </button>
                                <button className='button' onClick={() => onCloseClick()}>Fechar </button>
                            </div>
                            <TransformComponent>
                            {props.path?.startsWith("data:video") ? 
                            <video width="800" height="500" controls>
                                <source src={props.path} type={"video/webm"}/>
                            </video>
                            :
                            <img src={props.path ?? ""} alt="test" />
                            }
                            
                                
                            </TransformComponent>
                        </div>
                    )}
                </TransformWrapper>
            </div>
        </div>
    )
}
